import { FeecategoryGet } from "@kase/my-marathon-communication";
import { ApiSliceParams } from "../interfaces";
import { createListController } from "../utils";
import { FeeCategory } from "./interfaces";

export const makeFeeCategory = ({ connection, company }: ApiSliceParams) => {
    const {
        items: categories,
        allLoading: loading,
        listen,
        get,
        getOrLoad,
    } = createListController<FeecategoryGet, FeeCategory>({
        name: "feecategory",
        connection,
        list: (con) => con.feecategory.items({ company: company.value }),
    });

    const getByCode = (code: number) =>
        categories.peek().find((c) => c.code === code);

    return { categories, loading, get, getByCode, getOrLoad, listen };
};
